import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Body2 from "./Body2";
import Body4 from "./Body4";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageSluzby() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body4/>
      <Body2/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageSluzby;
